import React from "react";
import { Layers, Cpu, Telescope, FileCheck2 } from "lucide-react";

const STEPS = [
  {
    icon: Layers,
    title: "Drop in any content",
    body: "Paste text, share a link, or upload a PDF or image. We extract the meaningful parts so the engine analyses signal, not noise.",
  },
  {
    icon: Cpu,
    title: "Neural Routing",
    body: "Automated selection of specialized analytical lenses. N.E.T.R.A orchestrates multiple intelligence layers to cross-verify claims with extreme precision.",
  },
  {
    icon: Telescope,
    title: "Eight quiet checks",
    body: "Truthfulness, neutrality, source quality, tone, objectivity, author authority, corroboration, and internal logic, scored independently.",
  },
  {
    icon: FileCheck2,
    title: "A verdict you can defend",
    body: "Get a confidence-weighted verdict with the reasoning, key claims, red flags, and sources laid out plainly.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="border-t border-ink-border-subtle">
      <div className="max-w-[1260px] mx-auto px-6 md:px-8 py-24 md:py-32">
        <div className="max-w-2xl">
          <div className="text-sm text-brand font-medium">The workflow</div>
          <h2 className="mt-3 text-4xl md:text-5xl font-semibold text-white tracking-tight leading-[1.05]">
            From{" "}
            <span className="font-serif italic font-light text-zinc-300">a wall of text</span>
            <br />
            to a clear verdict.
          </h2>
          <p className="mt-5 text-zinc-400 text-lg leading-relaxed">
            No jargon, no theatre. Just a quiet, rigorous read-through that
            shows you the bones of any piece of content.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-4">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                className="rounded-2xl border border-ink-border-subtle bg-ink-surface/50 p-7 lift hover:border-zinc-700 hover:bg-ink-surface"
              >
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-xl bg-brand/10 border border-brand/20 flex items-center justify-center">
                    <Icon size={18} className="text-brand" strokeWidth={1.75} />
                  </div>
                  <div className="text-zinc-600 font-serif italic text-2xl">0{i + 1}</div>
                </div>
                <h3 className="mt-6 text-white text-xl font-medium tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-zinc-400 leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
